// test390
(390 && 0);
